import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

//Corrected Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyDrv_-tx-gCSE-51kStVH7VgK3Py1mfIbk",
  authDomain: "fpl365-notifications.firebaseapp.com",
  projectId: "fpl365-notifications",
  storageBucket: "fpl365-notifications.appspot.com",
  messagingSenderId: "574951790887",
  appId: "1:574951790887:web:470fbcfa18005b8c167102",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

// Request permission + token
export const requestForToken = async () => {
  try {
    const registration = await navigator.serviceWorker.register("/firebase-messaging-sw.js");
    await navigator.serviceWorker.ready;

    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      console.warn("Notification permission not granted by user.");
      return null;
    }

    const token = await getToken(messaging, {
      vapidKey: "BAfJ9MprRhQjb54xO6slV8ULy5wznOIsO6nUSf5NUcI8bdccMPEecNl44LXirCttBx-7i1iBdPJyqSR5dDo1qSw",
      serviceWorkerRegistration: registration,
    });

    if (token) {
      return token;
    } else {
      console.warn("No registration token available (getToken returned null).");
      return null;
    }
  } catch (err) {
    console.error("Error retrieving FCM token:", err);
    return null;
  }
};

// Handle foreground messages
onMessage(messaging, (payload) => {
  console.log("Foreground message received:", payload);
});
